import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import SuperAdminDelete from '../../images/SuperAdminDelete.png';

function DeleteModal({
  open,
  onClose,
  onConfirm,
  loading,
  projectName,
}) {
  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          padding: '32px',
          width: '451px',
          maxWidth: 'none',
        },
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '16px',
        }}
        >
          {/* Delete Icon */}
          <Box sx={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#FEE2E2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >
            <img src={SuperAdminDelete} alt="Delete" width="48" height="48" />
          </Box>

          {/* Title */}
          <Typography sx={{
            fontFamily: 'Inter !important',
            fontSize: '20px !important',
            fontWeight: '600 !important',
            lineHeight: '24px !important',
            color: '#3E1E40 !important',
          }}
          >
            Are you sure to delete this Project?
          </Typography>

          {/* Description */}
          <Typography sx={{
            fontFamily: 'Inter !important',
            fontSize: '14px !important',
            fontWeight: '400 !important',
            lineHeight: '20px !important',
            color: '#293855 !important',
          }}
          >
            You are about to delete the &quot;
            {projectName}
            &quot; project and this action can not be undone.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{
        padding: 0, paddingTop: '24px', gap: '10px', justifyContent: 'flex-start',
      }}
      >
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            padding: '12px 16px',
            borderRadius: '4px',
            border: '1px solid #E0E1E6',
            backgroundColor: '#FFF',
            color: '#666 !important',
            fontSize: '14px !important',
            fontFamily: 'Inter !important',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          sx={{
            padding: '12px 24px',
            borderRadius: '4px',
            backgroundColor: '#CC4525',
            color: 'white !important',
            fontSize: '14px !important',
            fontFamily: 'Inter !important',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#b53e2a',
            },
          }}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  projectName: PropTypes.string.isRequired,
};

DeleteModal.defaultProps = {
  loading: false,
};

export default DeleteModal;
